import axios from 'axios';
import { API_HOST } from '../helpers/constants';
import { headers } from '../utils';

const baseUrl = `${API_HOST}/blog-posts`;

export const createBlogPost = (payload) => {
  return axios.post(`${baseUrl}`, payload, { headers });
};

export const deleteBlogPost = (id) => {
  return axios.delete(`${baseUrl}/${id}`, { headers });
};

export const updateBlogPost = (id, payload) => {
  return axios.put(`${baseUrl}/${id}`, payload, { headers });
};
